import React from "react";
import { useState } from "react";
import "../../components/RegionList/RegionList.css";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const RegionList = ({ regionResponse, setOpenProfile, openProfile,GetId,openAddProfile,setOpenAddProfile }) => {
  function HandleChange(param) {
    
    GetId(param);
  }
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Add a null check using the optional chaining operator (?.)
  const visibleData = regionResponse?.slice(startIndex, endIndex);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  //console.log(regionResponse);
  return (
    <div className="container-fluid">
      <div className="regionList">
        <table>
          <tr className="regionListHeading">
            <th>S No.</th>
            <th>Region</th>
            <th>Region Code</th>
            <th>Action</th>
          </tr>
          {visibleData?.length > 0 ? (
            visibleData.map((region, index) => (
              <tr key={region.region_id}>
                <td>{++index}</td>
                <td>{region.region_name}</td>
                <td>{region.region_id}</td>
                <td>
                  <button
                    style={{
                      height: "35px",
                      width: "35px",
                      backgroundColor: "#F1F1F1",
                    }}
                    onClick={() => {setOpenProfile(!openProfile);
                      HandleChange(region.region_id); 
                      setOpenAddProfile(false);  
                    }}
                  >
                    <EditOutlinedIcon className="icon" />
                  </button>
                  <button
                    style={{
                      height: "35px",
                      width: "35px",
                      marginLeft: "5px",
                      backgroundColor: "#F4616F",
                      borderColor: "#FF0000",
                    }}
                  >
                    <DeleteOutlinedIcon className="icon" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">No data to display</td>
            </tr>
          )}
        </table>
        <nav
          aria-label="Page navigation"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1rem",
          }}
        >
          <ul className="pagination">
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </a>
            </li>
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                {currentPage - 1}
              </a>
            </li>
            <li className="page-item active">
              <a className="page-link">{currentPage}</a>
            </li>
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={endIndex >= regionResponse?.length}
              >
                {currentPage + 1}
              </a>
            </li>
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={endIndex >= regionResponse?.length}
              >
                Next
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default RegionList;
